/**
 * 公共模块接口列表
 */

import base from "./base"; // 导入接口域名列表
import axios from "@/axios/request"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const common = {
  // 配置info
  getSpConfigs(params) {
    return axios.get(`${base.sq}tools-center/api/open/spConfig/getSpConfigs`, {            
      params: params        
  });
    // return axios.post(`${base.sq}/tools-center/api/open/spConfig/getSpConfigs`, qs.stringify(params));
  },
  // 留资
  addUserCluesForMarket(params){ 
    // return axios.post(`${base.sq}marketing-center/api/open/userCluesExtend/addUserCluesForMarket`, params);
    // return axios.post(`${base.sq}tools-center/api/open/spConfig/addUserClues`, qs.stringify(params));
    return axios.get(`${base.sq}tools-center/api/open/spConfig/addUserClues`, {            
        params: params        
    });
  },
  // 获取用户协议
  findProtocolById(params) {
    return axios.get(`${base.sq}customer-center/api/protocol/api/open/findProtocolById`, {            
        params: params        
    });
  },
  // 获取省市区
  queryAreaListByPid(params) {
    return axios.get(`${base.sq}system-center/api/open/areaExpand/queryAreaListByPid`, {            
        params: params        
    });
  },
  // 获取门店列表
  getSpStoreList(params){ 
      // return axios.post(`${base.sq}tools-center/api/open/spStore/getSpStoreList`, params);
      return axios.get(`${base.sq}tools-center/api/open/spStore/getSpStoreList`, {            
          params: params        
      });
    
  },

  // // 菜单
  // getMenu(params) {
  //   return axios.post(
  //     `${base.sq}/api/blog/getMenu`,
  //     qs.stringify(params)
  //   );
  // }

  // 其他接口…………
};

export default common;
